const CLASSES = [];
for (let i = 5; i <= 11; i++) {
  CLASSES[i - 5] = {
    id: i,
    label: `${i} класс`,
  };
}
export const useScoolClasses = () => {
  return {
    CLASSES,
  };
};
